import { Swiper, Navigation, Keyboard, A11y } from 'swiper';

const floatingCardsSections = document.querySelectorAll(".adm-section-c10");

for (const floatingCardsSection of floatingCardsSections) {
    const scrollableContainer = floatingCardsSection.firstElementChild;
    const leftButton = scrollableContainer.nextElementSibling.querySelector(".adm-btn-c10-left-arrow");
    const rightButton = scrollableContainer.nextElementSibling.querySelector(".adm-btn-c10-right-arrow");
    const leftAligned = scrollableContainer.classList.contains("adm-div-c10-left-aligned");
    let contentContainerLeftMargin;
    let cardsContainerLeftMargin;
    let contentContainerRightMargin;
    let cardsContainerRightMargin;
    let scrollerTotalWidth;
    let scrollerLimitPosition;
    let currentPosition;
    let futurePosition;

    activateKeyboardNavigation(floatingCardsSection);

    const componentCTA = floatingCardsSection?.querySelector(".adm-btn.adm-bg-navy a");
    componentCTA?.addEventListener("focus", () => {
        scrollScreen(0);
    });

    addRightScrolling();
    addLeftScrolling();
    
    function scrollScreen(position) {
        for (const childrenElement of scrollableContainer.children) {
            childrenElement.style.transform = `translateX(${position}px)`;
            childrenElement.style.transition = `transform 1.5s`;
        }
    
        const isTextStillVisibleLeft = contentContainerLeftMargin + position >= 100;
        const isTextStillVisibleRight = contentContainerRightMargin - position >= 100;
        switch (true) {
            case position < 0 && position !== 0 && isTextStillVisibleLeft:
            case position > 0 && position !== 0 && isTextStillVisibleRight:
                leftButton.style.opacity = "0";
                rightButton.style.opacity = "0";
                window.addEventListener("resize", displaySideButtons);
                break;
        }
    }
    
    function displaySideButtons() {
        leftButton.style.opacity = "1";
        rightButton.style.opacity = "1";
        window.removeEventListener("resize", displaySideButtons);
    }
    
    function getFocusedElementC10() {
        if (document.activeElement.classList.contains("adm-figure-c10-card")) {
            return document.activeElement;
        } else if (document.activeElement.parentElement.parentElement.classList.contains("adm-div-c10-card-button")) {
            return document.activeElement.parentElement.parentElement;
        }
    }
    
    function activateKeyboardNavigation(componentSection) {
        for (const figure of componentSection.querySelectorAll(".adm-figure-c10-img")) {
            figure?.addEventListener("keydown", e => {
                if (e.keyCode === 9) {
                    setTimeout(() => {
                        updateC10Setting();
                        const focusedElementC10 = getFocusedElementC10();
                        const rect = focusedElementC10?.getBoundingClientRect();
                        const isOutsideScreenLeft = rect?.x < 0;
                        const isOutsideScreenRight = (rect?.x + rect?.width) > window.innerWidth;
    
                        if (isOutsideScreenRight) {
                            leftButton.style.display = "flex";
                            futurePosition = currentPosition - (window.innerWidth / 2);
                            scrollScreen(futurePosition);
                        } else if (isOutsideScreenLeft) {
                            rightButton.style.display = "block";
                            futurePosition = currentPosition + (window.innerWidth / 2);
                            scrollScreen(futurePosition);
                        }
                    }, 200);
                }
            });
        }
    }
    
    function addRightScrolling() {
        rightButton?.addEventListener("click", () => {
            updateC10Setting();
            leftButton.style.display = "flex";
            futurePosition = currentPosition - (window.innerWidth / 2);
    
            switch (leftAligned) {
                case true:
                    if (futurePosition >= -scrollerLimitPosition) {
                        scrollScreen(futurePosition);
                    } else {
                        rightButton.style.display = "none";
                        scrollScreen(-scrollerLimitPosition - 95);
                    }
                    break;
    
                case false:
                    if (futurePosition >= contentContainerRightMargin) {
                        scrollScreen(futurePosition);
                    } else {
                        rightButton.style.display = "none";
                        scrollScreen(0);
                    }
                    break;
            }
        })
    }
    
    function addLeftScrolling() {
        leftButton?.addEventListener("click", () => {
            updateC10Setting();
            rightButton.style.display = "block";
            futurePosition = currentPosition + (window.innerWidth / 2);
    
            switch (leftAligned) {
                case true:
                    if (futurePosition >= -contentContainerLeftMargin) {
                        leftButton.style.display = "none";
                        scrollScreen(0);
                    } else {
                        scrollScreen(futurePosition);
                    }
                    break;
    
                case false:
                    if (futurePosition <= scrollerLimitPosition) {
                        scrollScreen(futurePosition);
                    } else {
                        leftButton.style.display = "none";
                        scrollScreen(scrollerLimitPosition + 95);
                    }
                    break;
            }
        })
    }
    
    function updateC10Setting() {
        const contentContainer = scrollableContainer?.firstElementChild;
        const cardsContainer = contentContainer?.nextElementSibling;
    
        contentContainerLeftMargin = +window.getComputedStyle(contentContainer).marginLeft?.match(/(\d+)/)?.[0];
        cardsContainerLeftMargin = +window.getComputedStyle(cardsContainer).marginLeft?.match(/(\d+)/)?.[0];
        contentContainerRightMargin = +window.getComputedStyle(contentContainer).marginRight?.match(/(\d+)/)?.[0];
        cardsContainerRightMargin = +window.getComputedStyle(cardsContainer).marginRight?.match(/(\d+)/)?.[0];
        scrollerTotalWidth = contentContainerLeftMargin + cardsContainerLeftMargin + contentContainerRightMargin + cardsContainerRightMargin + contentContainer.offsetWidth + cardsContainer.offsetWidth;
        scrollerLimitPosition = scrollerTotalWidth - window.innerWidth;
        if (leftAligned) {
            currentPosition = -parseFloat(contentContainer?.style?.transform?.match(/(\d+)/)?.[0]) || 0;
        } else {
            currentPosition = parseFloat(contentContainer?.style?.transform?.match(/(\d+)/)?.[0]) || 0;
        }
    }
}

//MOBILE
const floatingCardsMobileSections = document.querySelectorAll(".adm-section-c10-mobile");

Array.prototype.forEach.call(floatingCardsMobileSections, (floatingCardsMobileSection, index) => {
    floatingCardsMobileSection.classList.add(`section-${index}`);

    var swiperc10 = new Swiper(`.adm-section-c10-mobile.section-${index} .swiper`, {
        modules: [Navigation, Keyboard, A11y],
        slidesPerView: 4,
        spaceBetween: 16,
        slidesPerGroup: 1,
        centeredSlides: true,
        speed: 1500,
        a11y: {
            prevSlideMessage: "Previous slide",
            nextSlideMessage: "Next slide"
        },
        keyboard: {
            enabled: true,
            onlyInViewPort: false
        },
        navigation: {
            nextEl: `.adm-section-c10-mobile.section-${index} .adm-c10-teaser-floating-arrow-right`,
            prevEl: `.adm-section-c10-mobile.section-${index} .adm-c10-teaser-floating-arrow-left`,
            disabledClass: "adm-arrow-disabled"
        }
    });

    swiperc10.on("realIndexChange",
        function () {
            const paginationSwiperc10 = floatingCardsMobileSection.querySelector(".adm-c10-teaser-floating-currentCard");
            if (swiperc10.realIndex + 1 < 10) {
                paginationSwiperc10.innerHTML = `0${swiperc10.realIndex + 1}`;
            } else {
                paginationSwiperc10.innerHTML = swiperc10.realIndex + 1;
            }
        });

    function disableFloatingCardsArrows() {
        floatingCardsMobileSection.querySelector(".adm-c10-teaser-floating-arrow-left").tabIndex = -1;
        floatingCardsMobileSection.querySelector(".adm-c10-teaser-floating-arrow-right").tabIndex = -1;
    }

    swiperc10.on("keyPress",
        (s) => {
            disableFloatingCardsArrows();
            Array.prototype.forEach.call(s.slides,
                (slide, slideIndex) => {
                    slide.addEventListener("focusin",
                        () => {
                            disableFloatingCardsArrows();
                            s.slideTo(slideIndex, 1500);
                        });
                });
        });
});